import { memo } from "react";

import { styled, Theme } from "@mui/material/styles";

import { zeffyOptionLabelClasses } from "./types";

export const StyledRoot = memo(
  styled("div")(({ theme }: { theme: Theme }) => ({
    [`&.${zeffyOptionLabelClasses.container}`]: {
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },

    [`& .${zeffyOptionLabelClasses.contentSection}`]: {
      display: "inline-flex",
      justifyContent: "flex-start",
    },

    [`& .${zeffyOptionLabelClasses.contentSectionCentered}`]: {
      alignItems: "center",
    },

    [`& .${zeffyOptionLabelClasses.children}`]: {
      alignItems: "center",
      display: "inline-flex",
      height: "fit-content",
      minHeight: theme.typography.body1.lineHeight,
    },

    [`& .${zeffyOptionLabelClasses.childrenSmall}`]: {
      minHeight: theme.typography.body2.lineHeight,
    },

    [`& .${zeffyOptionLabelClasses.labelSection}`]: {
      marginLeft: theme.spacing(1),
      display: "inline-flex",
    },

    [`& .${zeffyOptionLabelClasses.label}`]: {},

    [`& .${zeffyOptionLabelClasses.labelNeutral}`]: {
      color: theme.palette.text.neutral.moderate,
    },

    [`& .${zeffyOptionLabelClasses.labelForm}`]: {
      color: theme.palette.text.form.moderate,
    },

    [`&& .${zeffyOptionLabelClasses.tooltip}`]: {
      marginLeft: theme.spacing(0.5),
      display: "inline-block",
      height: theme.typography.body1.lineHeight,
    },

    [`& .${zeffyOptionLabelClasses.tooltipSmall}`]: {
      height: theme.typography.body2.lineHeight,
    },

    [`& .${zeffyOptionLabelClasses.disabledLabel}`]: {
      opacity: 0.4,
    },

    [`& .${zeffyOptionLabelClasses.error}`]: {
      marginTop: theme.spacing(1),
      color: theme.palette.text.danger.quiet,
    },

    [`& .${zeffyOptionLabelClasses.helperText}`]: {
      marginTop: theme.spacing(1),
      color: theme.palette.text.neutral.quiet,
    },

    [`&.${zeffyOptionLabelClasses.fullWidth}, .${zeffyOptionLabelClasses.fullWidth}`]: {
      width: "100%",
    },

    [`&.${zeffyOptionLabelClasses.clickable}, & .${zeffyOptionLabelClasses.clickable}`]: {
      cursor: "pointer",
    },
  }))
);
